import type { TokenStorageGateway } from "../application/ports/token-storage-gateway";
import type { Nullable } from "../core/types/nullable";
import { getAccessTokenCookie } from "@utils/access-token-cookie";

export class CookieTokenStorageGateway implements TokenStorageGateway {
  retrieveAccessToken(): Nullable<string> {
    return getAccessTokenCookie();
  }
}
